module.exports = __webpack_public_path__ + "static/royal-mail-997306616bc96eb5e65dfd5bb3b22214.svg";